<template>
  <article>
    <header class="container__fullwidth space-y-3 lg:space-y-6">
      <UtilityBadgeGroup :badges="badges" class="justify-center" />
      <SubpageHeader v-if="article.heading" :title="article.heading" :class="{ '!pb-12 lg:!pb-32': !article.image }" />
    </header>
    <section v-if="article.image" class="background-cut">
      <div class="container__fullwidth">
        <UtilityImage
          :src="article.image.url"
          :alt="article.image.alternativeText || article.image.name"
          class="imageWithBg w-full lg:w-8/12 lg:h-[30rem] mx-auto"
          image-class="object-contain"
          fulfill-background
        />
      </div>
    </section>
    <section class="bg-secondary-light py-12 lg:py-32 space-y-10 lg:space-y-16">
      <div v-if="slots.default" class="container__content grid grid-cols-1 lg:grid-cols-7">
        <div class="text-base text-grey-light lg:text-lg lg:col-start-2 lg:col-span-5">
          <slot />
        </div>
      </div>
      <div v-if="article.text" class="container__content grid grid-cols-1 lg:grid-cols-7">
        <div
          v-html="article.text"
          class="article marker:font-bold text-base text-grey-light lg:text-lg lg:col-start-2 lg:col-span-5 text-justify space-y-5"
        />
      </div>
      <LazyArticlesAttachments v-if="pdfs.length || audios.length || videos.length" :pdfs="pdfs" :audios="audios" :videos="videos" />
      <LazyArticlesGallery v-if="article.gallery?.length" :images="article.gallery" />
    </section>
  </article>
</template>
<script setup lang="ts">
import type { ArticleContent } from '~/utils/types'

const slots = useSlots()

const props = defineProps({
  badges: {
    type: Array,
    default: () => [],
  },
  article: {
    type: Object as PropType<ArticleContent>,
    required: true,
  },
  pdfs: {
    type: Array,
    default: [],
  },
  audios: {
    type: Array,
    default: [],
  },
  videos: {
    type: Array,
    default: [],
  },
})

const fixUrl = useFixUrl()

const bgUrl = computed(() => {
  return `url('${fixUrl(props.article.image?.formats?.medium?.url) || fixUrl(props.article.image?.url)}')`
})
</script>

<style scoped>
.imageWithBg {
  background-image: v-bind('bgUrl');
}
</style>
